import { render } from "./AddPharmacy.vue?vue&type=template&id=0cb56658&ts=true"
import script from "./AddPharmacy.ts?vue&type=script&lang=ts&external"
export * from "./AddPharmacy.ts?vue&type=script&lang=ts&external"

import "./AddPharmacy.scss?vue&type=style&index=0&lang=css&external"

import exportComponent from "../../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__